import { useState } from 'react';

export const useTranspositionSettings = () => {
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [chordColor, setChordColor] = useState('#2563eb');
  const [fontSize, setFontSize] = useState('12');
  const [chordFontSize, setChordFontSize] = useState(14);
  const [columns, setColumns] = useState('1');

  return {
    settingsOpen,
    setSettingsOpen,
    chordColor,
    setChordColor,
    fontSize,
    setFontSize,
    chordFontSize,
    setChordFontSize,
    columns,
    setColumns,
  };
};

